import { Button, Container, Divider, Stack, TextStyle, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { StoredPasskeyResult } from '@mews-commander/data-access';
import { LocalizedDateTimeFromUtc, TooltippedSpan } from '@mews-commander/ui';
import { PasskeyDeleteDialog } from './PasskeyDeleteDialog';
import { RenamePasskeyButton, RenamePasskeyDialog } from './RenamePasskey';

export const PasskeyList = ({ passkeys }: { passkeys: StoredPasskeyResult[] }) => (
    <>
        <Divider />
        {passkeys.map((passkey) => (
            <PasskeyListItem key={passkey.id} passkey={passkey} />
        ))}
    </>
);

const PasskeyListItem = ({ passkey }: { passkey: StoredPasskeyResult }) => {
    const [deletePasskeyDialogProps, toggleDeletePasskeyDialog] = useDialog();
    const [renamePasskeyDialogProps, toggleRenamePasskeyDialog] = useDialog();

    return (
        <>
            <Container padding={['200', '300', '200', '300']} data-test-id="passkey-list-item">
                <Stack vertical spacing="50">
                    <Stack spacing="100" itemAlignment="center" distribution="space-between">
                        <Stack spacing="100" itemAlignment="center">
                            <Typography textStyle={TextStyle.bodyLargeStrong} as="p">
                                {passkey.name || passkey.id}
                            </Typography>
                            <RenamePasskeyButton toggleRenameDialog={toggleRenamePasskeyDialog} />
                        </Stack>
                        <TooltippedSpan
                            tooltip={
                                passkey.isActive ? <LocalizedText textKey={TextKey.PasskeyActiveDeletionError} /> : null
                            }
                        >
                            <Button
                                type="button"
                                variant="tertiary"
                                size="small"
                                onClick={toggleDeletePasskeyDialog}
                                disabled={passkey.isActive}
                            >
                                <LocalizedText textKey={TextKey.Remove} />
                            </Button>
                        </TooltippedSpan>
                    </Stack>
                    {passkey.registrationDate && (
                        <Typography textStyle={TextStyle.bodyMedium} as="p">
                            <LocalizedText textKey={TextKey.Created} />
                            {UnicodeEntity.Colon} <LocalizedDateTimeFromUtc utcString={passkey.registrationDate} />
                        </Typography>
                    )}
                </Stack>
                {passkey.lastUpdatedDate && (
                    <Typography textStyle={TextStyle.bodyMedium} as="p" variant="tertiary">
                        <LocalizedText textKey={TextKey.SettingsSecurityPasskeysLastUsed} />
                        {UnicodeEntity.Colon} <LocalizedDateTimeFromUtc utcString={passkey.lastUpdatedDate} />
                    </Typography>
                )}
            </Container>
            <PasskeyDeleteDialog passkeyId={passkey.id} {...deletePasskeyDialogProps} />
            <RenamePasskeyDialog
                passkeyId={passkey.id}
                oldName={passkey.name || passkey.id}
                {...renamePasskeyDialogProps}
            />
            <Divider />
        </>
    );
};
